import { SchemaFormString, type FieldComponentProps } from 'formhell';
import { ViewAccountInCoreButton } from '../../ViewAccountInCoreButton/ViewAccountInCoreButton.component';
import { ViewCampaignInCoreButton } from '../../ViewCampaignInCore/ViewCampaignInCore.component';

const buttonRowStyle = { marginTop: 10, display: 'flex', flexDirection: 'row' } as const;

export const AppCoreAccountField = (props: FieldComponentProps<string>) => (
    <div className="app-sf-field-group">
        <SchemaFormString {...props} />
        <div style={buttonRowStyle}>
            <ViewAccountInCoreButton coreAccountId={props.value ?? ''} />
        </div>
    </div>
);

export const AppCoreCampaignField = (props: FieldComponentProps<string>) => (
    <div className="app-sf-field-group">
        <SchemaFormString {...props} />
        <div style={buttonRowStyle}>
            <ViewCampaignInCoreButton coreCampaignId={props.value ?? ''} />
        </div>
    </div>
);
